import { types } from "../types/types";

import { dataConexiones } from "../../../src/data";

export const getDataConexiones = (values) => ({
  type: types.getDataConexiones,
  payload: values,
});

export const getInsertConexionBancaria = (values) => ({
  type: types.getInsertConexionBancaria,
  payload: values,
});

export const getUpdatePasswordNeeded = (values) => ({
  type: types.getUpdatePasswordNeeded,
  payload: values,
});

export const importDataConexiones = (passwords) => {
  return async (dispatch) => {
    try {
      dispatch(getDataConexiones(passwords));
    } catch (error) {
      console.error(error);
    }
  };
};

export const importInsertConexionBancaria = () => {
  return async (dispatch) => {
    try {
      dispatch(getInsertConexionBancaria(dataConexiones.dataInsertBancaria));
    } catch (error) {
      console.error(error);
    }
  };
};

export const importUpdatePasswordNeeded = (values) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdatePasswordNeeded(values));
    } catch (error) {
      console.error(error);
    }
  };
};


